import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
  SLA_PROFILE_LIST,
  SLA_PROFILE_DATA,
  SLA_PROFILE_CREATE,
  SLA_PROFILE_UPDATE,
  SLA_PROFILE_DELETE,
  SLA_METRIC_CREATE,
  SLA_METRIC_UPDATE,
  SLA_METRIC_DELETE,
  CUSTOMER_SLA_LIST,
  CUSTOMER_SLA_ACTIVE,
  CUSTOMER_SLA_ASSIGN,
  CUSTOMER_SLA_DELETE,
} from "./actionType";
import {
  slaProfileListSuccess, slaProfileListFailure,
  slaProfileDataSuccess, slaProfileDataFailure,
  slaProfileCreateSuccess, slaProfileCreateFailure,
  slaProfileUpdateSuccess, slaProfileUpdateFailure,
  slaProfileDeleteSuccess, slaProfileDeleteFailure,
  slaMetricCreateSuccess, slaMetricCreateFailure,
  slaMetricUpdateSuccess, slaMetricUpdateFailure,
  slaMetricDeleteSuccess, slaMetricDeleteFailure,
  customerSlaListSuccess, customerSlaListFailure,
  customerSlaActiveSuccess, customerSlaActiveFailure,
  customerSlaAssignSuccess, customerSlaAssignFailure,
  customerSlaDeleteSuccess, customerSlaDeleteFailure,
} from "./action";
import {
  slaProfileListApi,
  slaProfileDataApi,
  slaProfileCreateApi,
  slaProfileUpdateApi,
  slaProfileDeleteApi,
  slaMetricCreateApi,
  slaMetricUpdateApi,
  slaMetricDeleteApi,
  customerSlaListApi,
  customerSlaActiveApi,
  customerSlaAssignApi,
  customerSlaDeleteApi,
} from "../../helpers/fakebackend_helper";

// FetchAPI resolves to the parsed body — see Task 24465 for what testing
// `response.data` here costs.
function* handle_slaProfileList() { try { yield put(slaProfileListSuccess(yield call(slaProfileListApi))); } catch (e) { yield put(slaProfileListFailure(e)); } }
function* handle_slaProfileData({ payload }) { try { yield put(slaProfileDataSuccess(yield call(slaProfileDataApi, payload))); } catch (e) { yield put(slaProfileDataFailure(e)); } }
function* handle_slaProfileCreate({ payload }) { try { yield put(slaProfileCreateSuccess(yield call(slaProfileCreateApi, payload))); } catch (e) { yield put(slaProfileCreateFailure(e)); } }
function* handle_slaProfileUpdate({ payload }) { try { yield put(slaProfileUpdateSuccess(yield call(slaProfileUpdateApi, payload))); } catch (e) { yield put(slaProfileUpdateFailure(e)); } }
function* handle_slaProfileDelete({ payload }) { try { yield put(slaProfileDeleteSuccess(yield call(slaProfileDeleteApi, payload))); } catch (e) { yield put(slaProfileDeleteFailure(e)); } }
function* handle_slaMetricCreate({ payload }) { try { yield put(slaMetricCreateSuccess(yield call(slaMetricCreateApi, payload))); } catch (e) { yield put(slaMetricCreateFailure(e)); } }
function* handle_slaMetricUpdate({ payload }) { try { yield put(slaMetricUpdateSuccess(yield call(slaMetricUpdateApi, payload))); } catch (e) { yield put(slaMetricUpdateFailure(e)); } }
function* handle_slaMetricDelete({ payload }) { try { yield put(slaMetricDeleteSuccess(yield call(slaMetricDeleteApi, payload))); } catch (e) { yield put(slaMetricDeleteFailure(e)); } }
function* handle_customerSlaList({ payload }) { try { yield put(customerSlaListSuccess(yield call(customerSlaListApi, payload))); } catch (e) { yield put(customerSlaListFailure(e)); } }
function* handle_customerSlaActive({ payload }) { try { yield put(customerSlaActiveSuccess(yield call(customerSlaActiveApi, payload))); } catch (e) { yield put(customerSlaActiveFailure(e)); } }
function* handle_customerSlaAssign({ payload }) { try { yield put(customerSlaAssignSuccess(yield call(customerSlaAssignApi, payload))); } catch (e) { yield put(customerSlaAssignFailure(e)); } }
function* handle_customerSlaDelete({ payload }) { try { yield put(customerSlaDeleteSuccess(yield call(customerSlaDeleteApi, payload))); } catch (e) { yield put(customerSlaDeleteFailure(e)); } }

export default function* SlaSaga() {
  yield all([
    fork(function* () { yield takeEvery(SLA_PROFILE_LIST, handle_slaProfileList); }),
    fork(function* () { yield takeEvery(SLA_PROFILE_DATA, handle_slaProfileData); }),
    fork(function* () { yield takeEvery(SLA_PROFILE_CREATE, handle_slaProfileCreate); }),
    fork(function* () { yield takeEvery(SLA_PROFILE_UPDATE, handle_slaProfileUpdate); }),
    fork(function* () { yield takeEvery(SLA_PROFILE_DELETE, handle_slaProfileDelete); }),
    fork(function* () { yield takeEvery(SLA_METRIC_CREATE, handle_slaMetricCreate); }),
    fork(function* () { yield takeEvery(SLA_METRIC_UPDATE, handle_slaMetricUpdate); }),
    fork(function* () { yield takeEvery(SLA_METRIC_DELETE, handle_slaMetricDelete); }),
    fork(function* () { yield takeEvery(CUSTOMER_SLA_LIST, handle_customerSlaList); }),
    fork(function* () { yield takeEvery(CUSTOMER_SLA_ACTIVE, handle_customerSlaActive); }),
    fork(function* () { yield takeEvery(CUSTOMER_SLA_ASSIGN, handle_customerSlaAssign); }),
    fork(function* () { yield takeEvery(CUSTOMER_SLA_DELETE, handle_customerSlaDelete); }),
  ]);
}
